var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 271,
    viewBox: "0 0 171 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2483 271L0 151.821V123.734H22.7494C31.8492 123.734 39.8115 122.469 46.6364 119.938C53.714 117.155 59.5277 113.233 64.0776 108.172C68.8803 103.112 72.1663 97.0388 73.9357 89.9538H0V61.867H73.5565C72.0399 55.2881 69.3858 49.4683 65.5942 44.4076C62.0554 39.3469 57.2528 35.4248 51.1862 32.6415C45.3725 29.605 38.2949 28.0868 29.9534 28.0868H0V0H171V28.0868H111.472C115.769 32.8945 119.308 38.0817 122.089 43.6485C125.122 49.2152 127.144 55.2881 128.155 61.867H171V89.9538H128.914C126.386 108.678 119.182 123.354 107.302 133.982C95.4213 144.356 80.1286 151.441 61.4235 155.237L135.738 271H68.2483Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.e3f84d0c6e952ad51f9d09c04c3d6567.svg";
export { ForwardRef as ReactComponent };